import type { Plugin } from 'vue'
import * as Sentry from '@sentry/vue'
import { router } from '@/router'

export const SentryPlugin: Plugin = {
  install: (app) => {
    const environment = import.meta.env.VITE_ENV
    const dsn = import.meta.env.VITE_SENTRY_DSN
    const isProd = environment === 'prod'

    if (!['stage', 'prod'].includes(environment) || !dsn) {
      return
    }

    if (!dsn) {
      if (isProd) {
        console.warn('[Sentry] VITE_SENTRY_DSN is not set — error tracking disabled.')
      }
      return
    }

    Sentry.init({
      app,
      dsn,
      environment: environment,
      release: import.meta.env.VITE_APP_VERSION,
      integrations: [
        Sentry.browserTracingIntegration({ router })
      ],
      tracesSampleRate: isProd ? 0.1 : 1.0
    })
  }
}
